import type { Customer } from './masters';
import { apiFetch } from './client';

/**
 * The quick add a booking needs: a customer by name and mobile, at the counter, while they wait.
 * Everything else the customer master holds (address, GSTIN, ID) is the website's full form; the
 * server checks the mobile against every person the company knows, staff included, and a clash comes
 * back as a 409 naming who already holds the number.
 */
export interface QuickCustomerInput {
  name: string;
  mobile: string;
  /** Optional, from the picker's "more details" (2026-10-15); the server takes both as they are. */
  city?: string | null;
  email?: string | null;
}

export function createCustomer(input: QuickCustomerInput) {
  return apiFetch<Customer>('/api/customer', { method: 'POST', body: input });
}
